module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-bodymatter element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-001"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-001-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-001-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-left"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_c('i', [_vm._v("Brackenbrae Holiday Park, Ayrshire, Scotland")])])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_c('i', [_vm._v("Sunday 27 May")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("oday was the worst ever.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They stopped talking when I walked into the kitchen. That’s always bad.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Mum’s face was pink, as if she’d put on too much of her blusher stuff. ‘Have you washed your hands?’ she said, in her snippy voice. I tried a smile. At school they tell us a smile’s infectious. Mum didn’t catch mine.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Dad was at the table, pouring wine. ‘Hello, Charlie. Had a good day?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘He was swimming,’ Mum said, as if I’d done something wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Dad smiled. ‘Ah, you’ve been swimming?’ He sounded like a kids television presenter I used to love. When I was five. I wish he’d stop speaking to me like that.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Ask him if the pool was busy,’ said Mum, and I understood.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I held up one hand and one finger. Actually, there was only me and an old man but I know it’s never good to hold up two fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Dad frowned but still managed to sound like Jolly Joe. ‘It’s early in the season,’ he said, with a kind of chuckle.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Mum turned from the oven and gave him a look. ‘It’s a bank holiday weekend, Richard, and we had five people in the swimming pool?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Six, if you count Charlie.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Charlie doesn’t count!’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Dad carried on as if she hadn’t said anything wrong. ‘It’ll get busier once the weather warms up. Don’t fret.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The casserole banged onto the table and the dishtowel flew at Dad’s face.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Don’t fret?’ Mum said, through her teeth, kind of low and threatening. ‘Christ! You’re like a bloody ostrich.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She doesn’t usually swear when she knows I’m listening, but she didn’t say, ‘Sorry, Charlie.’ In fact, she didn’t even seem to remember I was there.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Dad said nothing. He does that a lot, instead of arguing.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘How long are you going to carry on with this charade, Richard? Pretending everything’s just fine. Barging on with your obsession?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ostrich, charade, obsession? I didn’t get it. Still don’t. I reached for some bread and sank down into my chair to munch it. Dad took a chunk too but he didn’t eat his. Just picked out the soft, white centre and rolled it between his finger and thumb till it turned into a grey bullet. ‘This is neither the time nor the place,’ he said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It was like they were speaking in a secret code.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Mum passed me my plate and snapped at me, ‘Sit up properly.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Viv, please. Don’t take it out on the boy. It’s got nothing to do with him.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I watched the steam rising from the stew. I was starving, and I love beef stew. Even though it burned my tongue, I shovelled it in, so I could get away.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Don’t gobble your food, Charlie. Have you forgotten all your manners?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Come on, Vivienne. That’s not fair. Let’s have a nice family dinner and we’ll talk about this later.’ He reached for Mum’s hand but she snatched it off the table. He gave a little cough and moved his fork instead. Then, in his Jolly Joe voice, he said, ‘The summer staff arrive tomorrow. That’ll be fun.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I smiled, to please him, and took another piece of bread to dip into the gravy.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Dad’s good at choosing nice summer staff. ‘Natalie’s coming back to run the Kidz Klub. Charlie, you remember Natalie?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("How could I forget Natalie?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Mum said, ‘The pretty one who plans to be a schoolteacher?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("My cheeks started to go all warm.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I think our Charlie might be a little bit in love with Natalie,’ said Mum. ‘Look, he’s blushing.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I didn’t mind being embarrassed, if it made them happy. It was good to hear them laughing for once. Trying to look cool, I jabbed a piece of meat on my fork and stuck it in my mouth, like a cowboy at a campfire.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Mum stopped eating. ‘Hang on. "), _c('i', [_vm._v("One")]), _vm._v(" leader for the kids?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The bad atmosphere sneaked back into the room, sly as a cat.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘We need to save money, Richard, but that’s a risky way to go about it.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m not trying to save money and you’re right, she can’t run Kidz Klub on her own. The boy from Paris will help.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘What boy from Paris?’ Mum was all snappy again.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I found us a champion swimmer.’ Dad looked pleased with himself. ‘Ideal for pool duty "), _c('i', [_vm._v("and")]), _vm._v(" he sounds like an excellent Kidz Klub leader.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Sounds like? When did you meet him?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Dad doesn’t look so confident now. ‘I didn’t, actually.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘How come? You told me you’d sorted the summer staff months ago.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I did, but then the guy I’d taken on for the pool phoned. He’s got a permanent job in his local Asda. Good for him but it left me in a bit of a pickle, time-wise. I’d kept Sebastien’s application letter, he was my second choice, remember? So I offered him the job.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Without an interview? Are you off your head? He could be a total psycho.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m sure he’s not. Anyway, how can you interview someone who’s in Paris?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Skype? FaceTime?’ Mum’s lips went all screwed up. Like she was eating an apple before it was ripe. ‘You’ve never set eyes on this guy and you’re taking him on for the whole summer. This is going to cause trouble,’ she said. ‘I can sense it.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It’ll be fine.’ Dad took a sip of his wine.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Mum made her tutting noise. ‘For God’s sake! As if we don’t have enough to worry about, you’re taking on randoms to look after the kids.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Give me "), _c('i', [_vm._v("some")]), _vm._v(" credit, please, Viv. He’s on a two-week trial and it’s not as if he’s some guy who just walked in the gate. All the appropriate checks and paperwork have been completed. We agreed, didn’t we, that it makes sense to have workers who speak different languages if we’re aiming at a European clientele?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She chewed and swallowed for about a minute. ‘You’re going to have to abandon Phase Five.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Absolutely not.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And off they went again, arguing, as if they were the only ones with stuff to worry about. I wish they knew. Wish I could tell them.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I left the table, missing pudding, and it was apple crumble, my favourite. They were so busy arguing they didn’t even try to stop me. No one noticed me slipping out the door. That’s when I decided I had to do something.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Now it’s bedtime and I’ve got Dad’s gun hidden under the mattress.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Tomorrow they’ll notice me.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e09b994","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter001.vue
// module id = 78
// module chunks = 0